export const lineBreak = '<br/>';
export const maxLineLength = 15;